import { Popup, Row, Col } from "framework7-react";
import Ybutton from "controls/Ybutton";
import Ylink from "controls/Ylink";
import Yicon from "controls/Yicon";
import { useEffect, useRef } from "react";
import { attachFocusTrap, detachFocusTrap } from "helpers/common";

interface IerrorModal {
    popupHeaderText?: string;
    popupBodyText?: any;
    isShowFooter?: boolean;
    btnOnclick?: any;
    btnText? : string;
    linkText?: any;
    closeLinkText?: string;
    linkOnClick?: any;
    isOpened?: boolean
    id?: any
    focusElementId?: string // When we close Popup by Pressing Enter Key then Set Focus Element After Close Popup
}

const YapiErroModal: React.FC<IerrorModal> = ({ popupHeaderText, popupBodyText, isShowFooter, btnOnclick, btnText, linkText, closeLinkText, linkOnClick,isOpened, id, focusElementId }) => {
  
    // ADA: remember the control that was focused when the error appeared (e.g. "Add To Cart"),
    // so focus can return to it when the modal is closed via Close or OK
    const triggerElementRef = useRef<HTMLElement | null>(null);

    // ADA :: focus the heading on open and trap Tab / Shift + Tab in both directions
    // (re-uses the common helper so backward focus wraps inside the modal instead of escaping).
    // focus is moved at 500ms (after the open animation) to avoid the open flicker that a
    // mid-animation focus causes by scrolling the element into view.
    const setTabIndex = () => {
        triggerElementRef.current = document.activeElement as HTMLElement;
        setTimeout(() => {
            let mainDiv = document.querySelector(`#apiErrorModal`) as any;
            if (mainDiv) {
                let headerElement = mainDiv?.querySelector(".heading");
                headerElement?.focus();
                // preserve the Enter-on-last-element behavior for callers that pass focusElementId
                if (focusElementId) {
                    let elementArray = mainDiv.getElementsByTagName("a") as any;
                    let lastElement = elementArray[elementArray.length - 1];
                    lastElement?.addEventListener('keydown', (e) => {
                        if (e.keyCode === 13) {
                            let blockedTitle = document.querySelector(`#${focusElementId}`) as any;
                            if (blockedTitle) {
                                setTimeout(() => {
                                    blockedTitle.focus();
                                }, 500);
                            }
                        }
                    }, false);
                }
            }
            attachFocusTrap("apiErrorModal");
        }, 500)
    }

    // ADA: on close (Close / OK / Escape) tear down the focus trap and return focus to the control that opened the modal
    const handlePopupClosed = () => {
        detachFocusTrap("apiErrorModal");
        setTimeout(() => {
            triggerElementRef.current?.focus();
        }, 0);
    };

    return (
        <>
        <Popup closeByBackdropClick={false} className="invaild-alert-Model message-alert-Model api-error-model" id="apiErrorModal" onPopupOpen={setTabIndex} onPopupClosed={handlePopupClosed}>
            <div className="display-flex justify-content-space-between">
                <Ylink className="linkMain justify-content-flex-end" popupClose>
                  Close<Yicon text="xmark"></Yicon>
                </Ylink>
              </div>

                <div className="cardHeader">
                    <h2 className="heading" tabIndex={0}>Error</h2>
                </div>
                <div className="card-body">
                    <p className="SmallText" id="errorMessage">
                        <span tabIndex={0}></span>
                    </p>
                </div>
                <div className="cardfooter">
                    <div className="text-center">
                        <Row className="width-100">
                            <Col width="100" className="text-center">
                                <Ybutton popupClose>
                                    OK
                                </Ybutton>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Popup>
        </>
    )
}

export default YapiErroModal;